document.addEventListener('DOMContentLoaded', function () {
    const tabTriggers = document.querySelectorAll('.data-sheets-tab-trigger');
    const tabContents = document.querySelectorAll('.data-sheets-tab-content');

    tabTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function () {
        const tab = this.getAttribute('data-tab');
        tabTriggers.forEach((t) => t.classList.remove('active'));
        this.classList.add('active');
        tabContents.forEach((content) => {
          content.classList.remove('active');
          if (content.getAttribute('data-tab') === tab) {
            content.classList.add('active');
          }
        });
      });
    });

    const accordionTriggers = document.querySelectorAll('.accordion-trigger');

    accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function () {
        const content = this.nextElementSibling;
        const isActive = content.classList.contains('active');

        accordionTriggers.forEach((t) => {
          t.classList.remove('active');
          t.nextElementSibling.classList.remove('active');
        });

        if (!isActive) {
          content.classList.add('active');
          this.classList.add('active');
        }
      });
    });

    const popupTriggers = document.querySelectorAll('.popup-trigger');
    const popups = document.querySelectorAll('.popup');
    const closeButtons = document.querySelectorAll('.close-popup');

    const genericPopup = document.getElementById('generic-popup');
    const popupHeading = document.getElementById('popup-heading');
    const popupContentText = document.getElementById('popup-content-text');
    const popupContentButtons = document.getElementById('popup-content-buttons');

    function showPopup(trigger) {
      const popupId = trigger.getAttribute('data-popup-id');
      const [_, blockType, itemId] = popupId.split('-');
      
      const block = trigger.closest('.data-sheets-tab-content') || trigger.closest('.accordion-content');
      
      popupHeading.textContent = block.getAttribute('data-popup-heading');
      popupContentText.innerHTML = block.getAttribute('data-popup-content');
      
      popupContentButtons.innerHTML = '';
      
      const item = trigger.closest('.data-sheet-item');
      const subtitleSpan = item.querySelector('span[hidden]');
      
      for (let i = 1; i <= 3; i++) {
        const subtitleValue = subtitleSpan.getAttribute(`data-subtitle-${i}`);
        const subtitleUrl = subtitleSpan.getAttribute(`data-subtitle-${i}-url`);
        
        if (subtitleValue && subtitleValue.trim() !== '') {
          const button = document.createElement('a');
          button.href = subtitleUrl || '#';
          button.className = 'data-sheets-tab-content-button';
          button.textContent = subtitleValue;
          popupContentButtons.appendChild(button);
        }
      }

      genericPopup.style.display = 'block';
      document.body.style.overflow = 'hidden';
    }

    function hidePopup() {
      genericPopup.style.display = 'none';
      document.body.style.overflow = '';
    }

    popupTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        showPopup(trigger);
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', function () {
        hidePopup();
      });
    });

    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('popup-trigger')) {
        showPopup(event.target);
      }
      
      if (event.target.classList.contains('close-popup')) {
        hidePopup();
      }
    });

    window.addEventListener('click', function (e) {
      if (e.target === genericPopup) {
        hidePopup();
      }
    });

  });